import { withStyles } from '@material-ui/core';
import DeviceWidget from './DeviceWidget';
import styles from './styles';

export default withStyles(styles)(DeviceWidget);
